export default __webpack_public_path__ + "static/media/3AB_360_5.eb7f570c.jpg";